var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "pl-30 pr-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.form,
                    "label-width": "auto",
                  },
                },
                [
                  _c("h4", [_vm._v("运营产品：")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "产品类型：" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { min: 1 },
                          model: {
                            value: _vm.selType,
                            callback: function ($$v) {
                              _vm.selType = $$v
                            },
                            expression: "selType",
                          },
                        },
                        _vm._l(_vm.agentDevice, function (item) {
                          return item.taked == 1
                            ? _c(
                                "el-checkbox",
                                { attrs: { label: item.depend_type } },
                                [_vm._v(_vm._s(item.depend_name))]
                              )
                            : _vm._e()
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("基础信息")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "门头照：" } },
                    [
                      _c("upload", {
                        attrs: { "file-list": _vm.fileList, ratio: "1:1" },
                        on: { fileOk: _vm.fileOk },
                      }),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "abs",
                        attrs: { type: "hidden" },
                        model: {
                          value: _vm.form.avatar,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "avatar", $$v)
                          },
                          expression: "form.avatar",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "store_name",
                      attrs: { label: "商户名称：", prop: "store_name" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写商户名称" },
                        model: {
                          value: _vm.form.store_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "store_name", $$v)
                          },
                          expression: "form.store_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "mobile",
                      attrs: { label: "商家电话：", prop: "mobile" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写商家电话" },
                        model: {
                          value: _vm.form.mobile,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mobile", $$v)
                          },
                          expression: "form.mobile",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "cat_id",
                      attrs: { label: "行业分类：", prop: "cat_id" },
                    },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.categoryList,
                          props: { expandTrigger: "hover" },
                        },
                        model: {
                          value: _vm.form.cat_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cat_id", $$v)
                          },
                          expression: "form.cat_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "region_tag",
                      attrs: { label: "所在地区：", prop: "region_tag" },
                    },
                    [
                      _c("el-cascader", {
                        attrs: {
                          options: _vm.areaList,
                          props: { expandTrigger: "hover" },
                        },
                        model: {
                          value: _vm.form.region_tag,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "region_tag", $$v)
                          },
                          expression: "form.region_tag",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "address",
                      attrs: { label: "商户地址：", prop: "address" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写商户地址" },
                        model: {
                          value: _vm.form.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "address", $$v)
                          },
                          expression: "form.address",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户标签：", prop: "merchant_tag" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择商户标签" },
                          model: {
                            value: _vm.form.merchant_tag,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "merchant_tag", $$v)
                            },
                            expression: "form.merchant_tag",
                          },
                        },
                        _vm._l(_vm.merchantTags, function (tag) {
                          return _c("el-option", {
                            key: tag.value,
                            attrs: { label: tag.label, value: tag.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      ref: "longitude",
                      attrs: { label: "定位地址：", prop: "longitude" },
                    },
                    [
                      _vm.form.lng
                        ? _c("maps", {
                            attrs: {
                              center: { lng: _vm.form.lng, lat: _vm.form.lat },
                              zooms: 18,
                            },
                            on: { locationOk: _vm.locationOk },
                          })
                        : _c("maps", { on: { locationOk: _vm.locationOk } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商户介绍：" } },
                    [
                      _c("tinymce", {
                        attrs: { height: 300 },
                        model: {
                          value: _vm.form.introduce,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "introduce", $$v)
                          },
                          expression: "form.introduce",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  (_vm.id && _vm.form.is_major == 1) || (!_vm.id && !_vm.fid)
                    ? [
                        _c("h4", [_vm._v("分润信息")]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "分成方式：" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.divide_type_1,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "divide_type_1", $$v)
                                  },
                                  expression: "form.divide_type_1",
                                },
                              },
                              [
                                _c("el-radio-button", { attrs: { label: 0 } }, [
                                  _vm._v("比例分成"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio-button", { attrs: { label: 1 } }, [
                                  _vm._v("不给分成"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio-button", { attrs: { label: 2 } }, [
                                  _vm._v("入场费"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.divide_type_1 != 1
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "name",
                                    attrs: { label: "联系人：", prop: "name" },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请填写联系人姓名",
                                      },
                                      model: {
                                        value: _vm.form.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "name", $$v)
                                        },
                                        expression: "form.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    ref: "phone",
                                    attrs: {
                                      label: "手机号码：",
                                      prop: "phone",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        placeholder: "请填写联系人手机号码",
                                      },
                                      model: {
                                        value: _vm.form.phone,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "phone", $$v)
                                        },
                                        expression: "form.phone",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "fs-s2 text-gray" },
                                      [_vm._v("此手机号码会作为登录账户")]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.id
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "登录密码：" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请填写登录密码",
                                          },
                                          model: {
                                            value: _vm.form.password,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "password",
                                                $$v
                                              )
                                            },
                                            expression: "form.password",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.deviceNameObj, function (item, key) {
                    return _vm.selType.indexOf(item) > -1
                      ? [
                          _c("h4", [_vm._v(_vm._s(key) + "设置")]),
                          _vm._v(" "),
                          _c("percent", {
                            attrs: {
                              form: _vm.form,
                              "power-info": _vm.powerInfo,
                              name: _vm.config.goods_key[item],
                            },
                            on: { setDefaultPercent: _vm.setDefaultPercent },
                          }),
                          _vm._v(" "),
                          item == 0
                            ? [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "租借金额：" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex" },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "mr-10",
                                            model: {
                                              value:
                                                _vm.form.bao_fee_plan
                                                  .rent_fee_std,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.bao_fee_plan,
                                                  "rent_fee_std",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.bao_fee_plan.rent_fee_std",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "append" }, [
                                              _vm._v("元"),
                                            ]),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "ml-10",
                                            model: {
                                              value:
                                                _vm.form.bao_fee_plan
                                                  .rent_unit_minute_std,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form.bao_fee_plan,
                                                  "rent_unit_minute_std",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.bao_fee_plan.rent_unit_minute_std",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "append" }, [
                                              _vm._v("分钟"),
                                            ]),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "每天最高：" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        model: {
                                          value:
                                            _vm.form.bao_fee_plan.day_most_std,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.bao_fee_plan,
                                              "day_most_std",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.bao_fee_plan.day_most_std",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _vm._v("元"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "是否需要押金：" } },
                                  [
                                    _c("el-switch", {
                                      staticClass: "mr-20",
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        "inactive-text": "微信:",
                                      },
                                      model: {
                                        value:
                                          _vm.form.bao_fee_plan.is_deposit_wx,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.bao_fee_plan,
                                            "is_deposit_wx",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.bao_fee_plan.is_deposit_wx",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        "inactive-text": "支付宝:",
                                      },
                                      model: {
                                        value:
                                          _vm.form.bao_fee_plan.is_deposit_zfb,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.bao_fee_plan,
                                            "is_deposit_zfb",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.bao_fee_plan.is_deposit_zfb",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "押金：" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        attrs: {
                                          placeholder:
                                            (_vm.siteInfo
                                              .limit_deposit_amount_min || 0) +
                                            "-" +
                                            (_vm.siteInfo
                                              .limit_deposit_amount_max || 99) +
                                            "元之间",
                                        },
                                        model: {
                                          value:
                                            _vm.form.bao_fee_plan
                                              .deposit_amount_std,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form.bao_fee_plan,
                                              "deposit_amount_std",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.bao_fee_plan.deposit_amount_std",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _vm._v("元"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          item == 4
                            ? [
                                _vm._l(_vm.form.wash_fee_plan, function (item) {
                                  return _c(
                                    "el-form-item",
                                    { attrs: { label: item.name + "：" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex align-start" },
                                        [
                                          _c(
                                            "el-input",
                                            {
                                              staticClass: "mr-10",
                                              model: {
                                                value: item.money,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "money", $$v)
                                                },
                                                expression: "item.money",
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "append" },
                                                [
                                                  _vm._v(
                                                    "元（" +
                                                      _vm._s(item.unit_value) +
                                                      "分钟）"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                plain: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.checkFeeShow(
                                                    _vm.form.wash_fee_plan,
                                                    item,
                                                    "is_show"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.is_show == 1
                                                    ? "隐藏"
                                                    : "显示"
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.form.wash_laundry_fee_plan.length > 0
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "洗衣液设置：" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex" },
                                          [
                                            _vm._l(
                                              _vm.form.wash_laundry_fee_plan,
                                              function (item, index) {
                                                return [
                                                  _c(
                                                    "el-input",
                                                    {
                                                      staticClass: "mr-5",
                                                      model: {
                                                        value: item.money,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "money",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.money",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        { slot: "append" },
                                                        [
                                                          _vm._v(
                                                            "元 " +
                                                              _vm._s(item.name)
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      class:
                                                        index + 1 ==
                                                        _vm.form
                                                          .wash_laundry_fee_plan
                                                          .length
                                                          ? ""
                                                          : "mr-20",
                                                      attrs: {
                                                        type: "primary",
                                                        plain: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          item.is_show =
                                                            item.is_show == 0
                                                              ? 1
                                                              : 0
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.is_show == 1
                                                            ? "隐藏"
                                                            : "显示"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          item == 7 &&
                          _vm.form.business_mode &&
                          _vm.form.business_mode.std_condom &&
                          _vm.form.business_mode.std_condom.business_mode_type <
                            2
                            ? _vm._l(_vm.form.condom_fee_plan, function (item) {
                                return _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "套餐" + item.value + ":" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex align-start" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            model: {
                                              value: item.rent_unit_hour,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "rent_unit_hour",
                                                  $$v
                                                )
                                              },
                                              expression: "item.rent_unit_hour",
                                            },
                                          },
                                          _vm._l(
                                            _vm.config.condom_time,
                                            function (time) {
                                              return _c("el-option", {
                                                attrs: {
                                                  label: time + "小时",
                                                  value: time,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "mr-10",
                                            model: {
                                              value: item.rent_unit_fee,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "rent_unit_fee",
                                                  $$v
                                                )
                                              },
                                              expression: "item.rent_unit_fee",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "append" }, [
                                              _vm._v("元"),
                                            ]),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              plain: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.checkFeeShow(
                                                  _vm.form.condom_fee_plan,
                                                  item,
                                                  "rent_unit_show"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.rent_unit_show == 1
                                                  ? "隐藏"
                                                  : "显示"
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item == 6
                            ? _vm._l(_vm.form.blower_fee_plan, function (item) {
                                return _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "套餐" + item.value + ":" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "flex align-start" },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            model: {
                                              value:
                                                item.rent_blower_unit_minute,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "rent_blower_unit_minute",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.rent_blower_unit_minute",
                                            },
                                          },
                                          _vm._l(
                                            _vm.config.blower_time,
                                            function (time) {
                                              return _c("el-option", {
                                                attrs: {
                                                  label: time + "分钟",
                                                  value: time,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-input",
                                          {
                                            staticClass: "mr-10",
                                            model: {
                                              value: item.rent_blower_unit_fee,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item,
                                                  "rent_blower_unit_fee",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.rent_blower_unit_fee",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "append" }, [
                                              _vm._v("元"),
                                            ]),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              plain: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.checkFeeShow(
                                                  _vm.form.blower_fee_plan,
                                                  item,
                                                  "rent_blower_unit_show"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.rent_blower_unit_show == 1
                                                  ? "隐藏"
                                                  : "显示"
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          item == 3 &&
                          _vm.form.business_mode &&
                          _vm.form.business_mode.std_zhuang &&
                          _vm.form.business_mode.std_zhuang
                            .business_mode_type == 2
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "支持大功率：" } },
                                      [
                                        _c("el-switch", {
                                          staticClass: "mr-20",
                                          attrs: {
                                            "active-value": 1,
                                            "inactive-value": 0,
                                          },
                                          model: {
                                            value: _vm.form.zhuang_high_power,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "zhuang_high_power",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.zhuang_high_power",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "mr-20",
                                        attrs: { label: "充电电费：" },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            model: {
                                              value:
                                                _vm.form.zhuang_electrcity_plan
                                                  .rent_zhuang_electrcity_fee,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form
                                                    .zhuang_electrcity_plan,
                                                  "rent_zhuang_electrcity_fee",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.zhuang_electrcity_plan.rent_zhuang_electrcity_fee",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "append" }, [
                                              _vm._v("元/度"),
                                            ]),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "服务费模式：" } },
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value:
                                                _vm.form.zhuang_electrcity_plan
                                                  .rent_zhuang_service_mode,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form
                                                    .zhuang_electrcity_plan,
                                                  "rent_zhuang_service_mode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.zhuang_electrcity_plan.rent_zhuang_service_mode",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 0 } },
                                              [_vm._v("按电量度数收费")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 2 } },
                                              [_vm._v("按小时收费")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: 1 } },
                                              [_vm._v("按功率套餐收费")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.form.zhuang_electrcity_plan
                                  .rent_zhuang_service_mode == 0
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-wrap" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "mr-20",
                                            attrs: { label: "服务费：" },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                model: {
                                                  value:
                                                    _vm.form
                                                      .zhuang_electrcity_plan
                                                      .rent_zhuang_service_fee,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form
                                                        .zhuang_electrcity_plan,
                                                      "rent_zhuang_service_fee",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.zhuang_electrcity_plan.rent_zhuang_service_fee",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "append" },
                                                  [_vm._v("元/度")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.form.zhuang_electrcity_plan
                                  .rent_zhuang_service_mode == 2
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-wrap" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "mr-20",
                                            attrs: { label: "服务费：" },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                model: {
                                                  value:
                                                    _vm.form
                                                      .zhuang_electrcity_plan
                                                      .rent_zhuang_service_fee,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form
                                                        .zhuang_electrcity_plan,
                                                      "rent_zhuang_service_fee",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.zhuang_electrcity_plan.rent_zhuang_service_fee",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "append" },
                                                  [_vm._v("元/小时")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.form.zhuang_electrcity_plan
                                  .rent_zhuang_service_mode == 1
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-wrap" },
                                      [
                                        _vm._l(
                                          _vm.form.zhuang_electrcity_plan.plan,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              { staticClass: "flex " },
                                              [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "mr-20",
                                                    attrs: {
                                                      label:
                                                        "功率" + index + "：",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex align-center",
                                                      },
                                                      [
                                                        _c(
                                                          "el-input",
                                                          {
                                                            attrs: {
                                                              value:
                                                                item.rent_zhuang_unit_power_min,
                                                              disabled: "",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "append",
                                                              },
                                                              [_vm._v("W")]
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "pl-10 pr-10",
                                                          },
                                                          [_vm._v("—")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-input",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                index == 10,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.setServicePowerMax(
                                                                  item
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                item.rent_zhuang_unit_power_max,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "rent_zhuang_unit_power_max",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.rent_zhuang_unit_power_max",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "append",
                                                              },
                                                              [_vm._v("W")]
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    staticClass: "mr-20",
                                                    attrs: { label: "金额：" },
                                                  },
                                                  [
                                                    _c(
                                                      "el-input",
                                                      {
                                                        model: {
                                                          value:
                                                            item.rent_zhuang_unit_fee,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "rent_zhuang_unit_fee",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.rent_zhuang_unit_fee",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "append" },
                                                          [
                                                            _vm._v(
                                                              "元/" +
                                                                _vm._s(
                                                                  item.rent_zhuang_unit_hour
                                                                ) +
                                                                "小时"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                index > 4
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        staticClass: "mr-20",
                                                        staticStyle: {
                                                          height: "0.54rem",
                                                        },
                                                        attrs: {
                                                          type: "danger",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.delServiceZhuangPower(
                                                              index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("删除")]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "add_btn_z",
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addServiceZhuangPower()
                                              },
                                            },
                                          },
                                          [_vm._v("增加套餐")]
                                        ),
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          item == 3 &&
                          _vm.form.business_mode &&
                          _vm.form.business_mode.std_zhuang &&
                          _vm.form.business_mode.std_zhuang
                            .business_mode_type == 1
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "支持大功率：" } },
                                      [
                                        _c("el-switch", {
                                          staticClass: "mr-20",
                                          attrs: {
                                            "active-value": 1,
                                            "inactive-value": 0,
                                          },
                                          model: {
                                            value: _vm.form.zhuang_high_power,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "zhuang_high_power",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.zhuang_high_power",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_daymost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_daymost",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_daymost",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_electrcity_fee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_electrcity_fee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_electrcity_fee",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_service_fee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_service_fee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_service_fee",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.form.zhuang_fee_plan.plan,
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { staticClass: "flex" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "mr-20",
                                            attrs: {
                                              label: "功率" + index + "：",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex align-center",
                                              },
                                              [
                                                _c(
                                                  "el-input",
                                                  {
                                                    attrs: {
                                                      value:
                                                        item.rent_zhuang_unit_power_min,
                                                      disabled: "",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "append" },
                                                      [_vm._v("W")]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pl-10 pr-10",
                                                  },
                                                  [_vm._v("—")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "el-input",
                                                  {
                                                    attrs: {
                                                      disabled: index == 10,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.setPowerMax(
                                                          item
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        item.rent_zhuang_unit_power_max,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          item,
                                                          "rent_zhuang_unit_power_max",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.rent_zhuang_unit_power_max",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "append" },
                                                      [_vm._v("W")]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "mr-20",
                                            attrs: { label: "金额：" },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                model: {
                                                  value:
                                                    item.rent_zhuang_unit_fee,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "rent_zhuang_unit_fee",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.rent_zhuang_unit_fee",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "append" },
                                                  [
                                                    _vm._v(
                                                      "元/" +
                                                        _vm._s(
                                                          item.rent_zhuang_unit_hour
                                                        ) +
                                                        "小时"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        index > 4
                                          ? _c(
                                              "el-button",
                                              {
                                                staticClass: "mr-20",
                                                staticStyle: {
                                                  height: "0.54rem",
                                                },
                                                attrs: {
                                                  type: "danger",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delZhuangPower(
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v("删除")]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "add_btn_z",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addZhuangPower()
                                      },
                                    },
                                  },
                                  [_vm._v("增加套餐")]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          item == 3 &&
                          _vm.form.business_mode &&
                          _vm.form.business_mode.std_zhuang &&
                          _vm.form.business_mode.std_zhuang
                            .business_mode_type == 0
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "支持大功率：" } },
                                      [
                                        _c("el-switch", {
                                          staticClass: "mr-20",
                                          attrs: {
                                            "active-value": 1,
                                            "inactive-value": 0,
                                          },
                                          model: {
                                            value: _vm.form.zhuang_high_power,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "zhuang_high_power",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.zhuang_high_power",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_daymost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_daymost",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_daymost",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_electrcity_fee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_electrcity_fee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_electrcity_fee",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_service_fee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_service_fee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_service_fee",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _vm._l(
                                      _vm.form.zhuang_hourfeeplan,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          { staticClass: "flex" },
                                          [
                                            _vm.checkHidRole("showTenPower")
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "套餐" +
                                                        item.value +
                                                        ":",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex align-start",
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            model: {
                                                              value:
                                                                item.rent_zhuang_unit_hour,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "rent_zhuang_unit_hour",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.rent_zhuang_unit_hour",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.config
                                                              .zhuang_time,
                                                            function (time) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      time +
                                                                      "小时",
                                                                    value: time,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-input",
                                                          {
                                                            staticClass:
                                                              "mr-10",
                                                            model: {
                                                              value:
                                                                item.rent_zhuang_unit_fee,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "rent_zhuang_unit_fee",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.rent_zhuang_unit_fee",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "append",
                                                              },
                                                              [_vm._v("元")]
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary",
                                                              plain: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.checkFeeShow(
                                                                  _vm.form
                                                                    .zhuang_hourfeeplan,
                                                                  item,
                                                                  "rent_zhuang_unit_show"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.rent_zhuang_unit_show ==
                                                                  1
                                                                  ? "隐藏"
                                                                  : "显示"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        index > 3
                                                          ? _c(
                                                              "el-button",
                                                              {
                                                                staticClass:
                                                                  "mr-20",
                                                                attrs: {
                                                                  type: "danger",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.delZhuangHour(
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("删除")]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "add_btn_z",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addZhuangHour()
                                          },
                                        },
                                      },
                                      [_vm._v("增加套餐")]
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          item == 3 &&
                          _vm.form.business_mode &&
                          _vm.form.business_mode.std_zhuang &&
                          _vm.form.business_mode.std_zhuang
                            .business_mode_type == 3
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "支持大功率：" } },
                                      [
                                        _c("el-switch", {
                                          staticClass: "mr-20",
                                          attrs: {
                                            "active-value": 1,
                                            "inactive-value": 0,
                                          },
                                          model: {
                                            value: _vm.form.zhuang_high_power,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "zhuang_high_power",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.zhuang_high_power",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex flex-wrap" },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_daymost,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_daymost",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_daymost",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_electrcity_fee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_electrcity_fee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_electrcity_fee",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: { type: "hidden" },
                                      model: {
                                        value:
                                          _vm.form.zhuang_fee_plan
                                            .rent_zhuang_service_fee,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.zhuang_fee_plan,
                                            "rent_zhuang_service_fee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.zhuang_fee_plan.rent_zhuang_service_fee",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _vm._l(
                                      _vm.form.zhuang_minfeeplan,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          { staticClass: "flex" },
                                          [
                                            _vm.checkHidRole("showTenPower")
                                              ? _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "套餐" +
                                                        item.value +
                                                        ":",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex align-start",
                                                      },
                                                      [
                                                        _c(
                                                          "el-input",
                                                          {
                                                            staticClass:
                                                              "mr-10",
                                                            model: {
                                                              value:
                                                                item.rent_zhuang_unit_min,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "rent_zhuang_unit_min",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.rent_zhuang_unit_min",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "append",
                                                              },
                                                              [_vm._v("分钟")]
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-input",
                                                          {
                                                            staticClass:
                                                              "mr-10",
                                                            model: {
                                                              value:
                                                                item.rent_zhuang_unit_fee,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "rent_zhuang_unit_fee",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.rent_zhuang_unit_fee",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "append",
                                                              },
                                                              [_vm._v("元")]
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-button",
                                                          {
                                                            attrs: {
                                                              type: "primary",
                                                              plain: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.checkFeeShow(
                                                                  _vm.form
                                                                    .zhuang_minfeeplan,
                                                                  item,
                                                                  "rent_zhuang_unit_show"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.rent_zhuang_unit_show ==
                                                                  1
                                                                  ? "隐藏"
                                                                  : "显示"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        index > 3
                                                          ? _c(
                                                              "el-button",
                                                              {
                                                                staticClass:
                                                                  "mr-20",
                                                                attrs: {
                                                                  type: "danger",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.delZhuangMin(
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [_vm._v("删除")]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "add_btn_z",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addZhuangMin()
                                          },
                                        },
                                      },
                                      [_vm._v("增加套餐")]
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          item == 2
                            ? _vm._l(_vm.form.zhen_fee_plan, function (item) {
                                return _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: item.rent_major_title + "：",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex align-start flex-wrap",
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "mr-20",
                                            attrs: { label: "套餐价：" },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                model: {
                                                  value: item.rent_major_fee,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "rent_major_fee",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.rent_major_fee",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "append" },
                                                  [_vm._v("元")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticClass: "mr-20",
                                            attrs: { label: "按摩时长：" },
                                          },
                                          [
                                            _c(
                                              "el-input",
                                              {
                                                model: {
                                                  value: item.rent_major_unit,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "rent_major_unit",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.rent_major_unit",
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "append" },
                                                  [_vm._v("分钟")]
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              plain: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.checkFeeShow(
                                                  _vm.form.zhen_fee_plan,
                                                  item,
                                                  "rent_is_show"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.rent_is_show == 1
                                                  ? "隐藏"
                                                  : "显示"
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              })
                            : _vm._e(),
                        ]
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _c("h4", [_vm._v("商户权限")]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "基本权限：" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.powerInfo.check_order == 1,
                              expression: "powerInfo.check_order == 1",
                            },
                          ],
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.form.check_order,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "check_order", $$v)
                            },
                            expression: "form.check_order",
                          },
                        },
                        [_vm._v("查看订单")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.powerInfo.withdraw_right == 1 ||
                                _vm.checkRoles(["partner"]),
                              expression:
                                "powerInfo.withdraw_right == 1 || checkRoles(['partner'])",
                            },
                          ],
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.form.withdraw_right,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "withdraw_right", $$v)
                            },
                            expression: "form.withdraw_right",
                          },
                        },
                        [_vm._v("提现")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.form.advance_buletooth,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "advance_buletooth", $$v)
                            },
                            expression: "form.advance_buletooth",
                          },
                        },
                        [_vm._v("下单先匹配蓝牙")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.checkRoles(["partner"]),
                              expression: "checkRoles(['partner'])",
                            },
                          ],
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: _vm.form.skipzfb,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "skipzfb", $$v)
                            },
                            expression: "form.skipzfb",
                          },
                        },
                        [_vm._v("跳转支付宝")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.checkRoles(["partner"]) && _vm.checkHidRole("storeTxsxf")
                    ? _c(
                        "div",
                        [
                          _c("h4", [_vm._v("提现手续费")]),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "收取方式：" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.withdrawFeeObj.config_mode,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.withdrawFeeObj,
                                        "config_mode",
                                        $$v
                                      )
                                    },
                                    expression: "withdrawFeeObj.config_mode",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("跟随原配置"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("单独比例"),
                                  ]),
                                  _vm._v(" "),
                                  _c("el-radio", { attrs: { label: 2 } }, [
                                    _vm._v("单独金额"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.withdrawFeeObj.config_mode == 1
                            ? [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "提现手续费比例：" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "flex1",
                                        attrs: {
                                          oninput:
                                            "value=value.replace(/[^\\d.]/g,'')",
                                        },
                                        model: {
                                          value:
                                            _vm.withdrawFeeObj.withdraw_rate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.withdrawFeeObj,
                                              "withdraw_rate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "withdrawFeeObj.withdraw_rate",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _vm._v("%"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.withdrawFeeObj.config_mode == 2
                            ? [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "提现手续费金额：" } },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticClass: "flex1",
                                        attrs: {
                                          oninput:
                                            "value=value.replace(/[^\\d.]/g,'')",
                                        },
                                        model: {
                                          value:
                                            _vm.withdrawFeeObj.withdraw_amount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.withdrawFeeObj,
                                              "withdraw_amount",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "withdrawFeeObj.withdraw_amount",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _vm._v("元"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.checkRoles(["partner"]) &&
                          _vm.checkHidRole("storeYjthfs")
                            ? [
                                _c("h4", [_vm._v("押金退回方式")]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "退回方式：" } },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.form.deposit_is_backtrack,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "deposit_is_backtrack",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.deposit_is_backtrack",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [_vm._v("跟随系统配置")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [_vm._v("押金原路退回")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 2 } },
                                          [_vm._v("押金退回到余额")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "mt-10 mb-10",
                          attrs: { type: "primary", disabled: _vm.clickSubmit },
                          on: {
                            click: function ($event) {
                              return _vm.onSubmit("form")
                            },
                          },
                        },
                        [_vm._v("立即提交")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }